import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import countries from "../../assets/store/countries";
import InputError from "../typography/InputError";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  box-sizing: border-box;

  select {
    box-sizing: border-box;
    padding: 0px 10px;
    border: 1px solid #8e8e8e;
    background-color: white;
    color: ${colors.black};
    font-size: ${fontSize.xs};
    min-width: clamp(8rem, (160 / 1920) * 100vw, 10rem);
    height: 38px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%2010%207%22%20xmlns%3D%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M0%200l5%207%205-7H0z%22%20fill%3D%22black%22/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 10px 7px;
    border-radius: 0;
    outline: none;
    cursor: pointer;
  }

  div{
    width: 100%;
  }

  input {
    box-sizing: border-box;
    width: inherit;
    border: 1px solid
      ${({ $hasError }) => ($hasError ? colors.black : colors.border)};
    padding: 12px 10px;
    outline: none;
    caret-color: ${colors.black};
    font-size: ${fontSize.xxs};
  }
`;
const Row = styled.div`
  display: flex;
  gap: 16px;
`;

function PhoneField({
  value,
  countryCode,
  error,
  onChangeValue,
  onChangeCode,
}) {
  return (
    <Wrapper $hasError={!!error}>
      <Row>
        <select
          value={countryCode}
          onChange={(e) => onChangeCode(e.target.value)}
        >
          {countries.map((c) => (
            <option key={c.code} value={c.code}>
              {c.name} ({c.code})
            </option>
          ))}
        </select>
        <div>
          <input
            type="tel"
            placeholder="*PHONE NUMBER"
            value={value}
            error={error}
            onChange={(e) => onChangeValue(e.target.value)}
          />
          {error && <InputError error={error} />}
        </div>
      </Row>
    </Wrapper>
  );
}

export default PhoneField;
